"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.seal");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _editorForVue = require("@wangeditor/editor-for-vue");
var _upload = _interopRequireDefault(require("@/components/uploadImg/upload.vue"));
var _ossUpload = require("@/utils/ossUpload");
var _withdrawalManagement = require("@/api/financialManagement/withdrawalManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PersonalizedConfiguration',
  components: {
    upload: _upload.default,
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar
  },
  data: function data() {
    return {
      form: {
        description: '',
        backgroundImage: '',
        withdrawContext: ''
      },
      rules: {
        // backgroundImage: [
        //   { required: true, message: '请输入提现审核说明提醒', trigger: 'blur' }
        // ],
        // description: [
        //   { required: true, message: '请上传余额提现背景图', trigger: 'blur' }
        // ],
        // withdrawContext: [
        //   { required: true, message: '请输入余额提现说明', trigger: 'blur' }
        // ]
      },
      // 富文本
      editor: null,
      toolbarConfig: {
        // excludeKeys: ['group-image', 'group-video']
        toolbarKeys: ['bold', 'italic', 'fontSize', 'lineHeight']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl, '', '', {
                        style: 'max-width:350px;'
                      });
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log('error ->', _t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      mode: 'default',
      // or 'simple'
      EditorOpen: true // 显示隐藏
    };
  },
  created: function created() {
    this.queryWithdrawIndividuation();
  },
  methods: {
    queryWithdrawIndividuation: function () {
      var _queryWithdrawIndividuation2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _withdrawalManagement.queryWithdrawIndividuation)();
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                console.log('res.data', res.data);
                this.form = (0, _objectSpread2.default)({}, res.data);
              } else {
                this.$message.error(res.msg || '获取失败');
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$message.error('获取失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function queryWithdrawIndividuation() {
        return _queryWithdrawIndividuation2.apply(this, arguments);
      }
      return queryWithdrawIndividuation;
    }(),
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor);
      // 一定要用 Object.seal() ，否则会报错
    },
    onPictureAddress: function onPictureAddress(data) {
      this.form[data.name] = data.pictureUrl;
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.$confirm('是否保存此设置？', '提示', {
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(function () {
            _this.updateIndividuationRule();
          });
        } else {
          _this.$message.error('请填写所有必填项');
          return false;
        }
      });
    },
    handleReset: function handleReset() {
      this.form = {
        description: '',
        backgroundImage: '',
        withdrawContext: ''
      };
      this.$refs.form.resetFields();
    },
    updateIndividuationRule: function () {
      var _updateIndividuationRule2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, response, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.form);
              _context3.n = 1;
              return (0, _withdrawalManagement.updateIndividuationRule)(params);
            case 1:
              response = _context3.v;
              if (response.code === 0) {
                this.$message.success('保存成功');
                this.queryWithdrawIndividuation();
              } else {
                this.$message.error(response.msg || '保存失败');
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.$message.error('保存失败');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function updateIndividuationRule() {
        return _updateIndividuationRule2.apply(this, arguments);
      }
      return updateIndividuationRule;
    }()
  }
};